<template>
  <div v-if="hasRight">

    <b-button v-spaceduck-collapse="`newcas-c`"
              class="btn-collapse">
      NewCas KKM
    </b-button>

    <spaceduck-collapse id="newcas-c"
                        @show="onShow">

      <InputGroup label="Url"
                  class="mt-3"
                  type="text"
                  v-model="requestUrl"/>

      <InputGroup label="fmNumber"
                  class="mt-3"
                  type="text"
                  v-model="fmNumber"/>

      <InputGroup label="registrationNumber"
                  class="mt-3"
                  type="text"
                  v-model="registrationNumber"/>

      <InputGroup v-model="serviceName"
                  class="mt-3"
                  :label="$t('name_of_service_in_cheque')"/>

      <ServiceMultiSelect :label="$t('pay_methods_cash')"
                          :dblclick="false"
                          model="pay_method"
                          title="translatedTitle"
                          class="mt-3"
                          :dbsearch="false"
                          :prepopulatedOptions="payMethods"
                          v-model="cashMethods"/>

      <div class="text-right mt-4">
        <button class="btn btn-themed btn-themed-squared"
                @click="saveSettings"
                :disabled="loading">
          {{ $t('save') }}
        </button>
      </div>

    </spaceduck-collapse>
  </div>
</template>

<script setup>
import { useStore } from "vuex"
import {computed, getCurrentInstance, onBeforeMount, onMounted, ref} from "vue"
import InputGroup from "@/components/form/InputGroup.vue"
import { ClinicService } from "@/services/api/clinic.api.service"
import SpaceduckCollapse from "@/components/parts/general/SpaceduckCollapse.vue"
import ServiceMultiSelect from "@/components/form/ServiceMultiSelect.vue"

const store = useStore()
let i18n = null
let noty = null
const loading = ref(false)

const fmNumber = ref('')
const requestUrl = ref('')
const registrationNumber = ref('')
const cashMethods = ref([])
const serviceName = ref('')

const clinic = computed(() => store.state.auth.clinic)
const branchId = computed(() => store.state.auth.branch)
const rights = computed(() => store.state.auth.rights || [])
const superadmin = computed(() => store.state.auth.superadmin)
const hasRight = computed(() => rights.value.includes('newcas'))
const payMethods = computed(() => store.state.auth.pay_methods)

const onShow = () => {
  fmNumber.value = store.getters.dynamicConfigValue('newcasFmNumber', branchId.value)
  registrationNumber.value = store.getters.dynamicConfigValue('newcasRegistrationNumber', branchId.value)
  requestUrl.value = store.getters.dynamicConfigValue('newcasRequestUrl', branchId.value)
  serviceName.value = store.getters.dynamicConfigValue('newcasServiceName', branchId.value)
  let tmpCashMethods = store.getters.dynamicConfigValue('newcasCashMethods', branchId.value)
  if(tmpCashMethods) cashMethods.value = payMethods.value.filter(p => tmpCashMethods.includes(p.id))
}

onBeforeMount(() => {
  const instance = getCurrentInstance()
  i18n = instance?.ctx?.$i18n
  noty = instance?.appContext?.app?.noty
})

onMounted(() => {
  onShow()
})

const saveSettings = async () => {
  await ClinicService.saveDynamicConfigs([
    {
      id: 'newcasRequestUrl',
      value: requestUrl.value,
      subgroup: 'newcas',
      branchId: branchId.value
    },
    {
      id: 'newcasFmNumber',
      value: fmNumber.value,
      subgroup: 'newcas',
      branchId: branchId.value
    },
    {
      id: 'newcasRegistrationNumber',
      value: registrationNumber.value,
      subgroup: 'newcas',
      branchId: branchId.value
    },
    {
      id: 'newcasServiceName',
      value: serviceName.value,
      subgroup: 'newcas',
      branchId: branchId.value
    },
    {
      id: 'newcasCashMethods',
      value: cashMethods.value.map(x => x.id),
      subgroup: 'newcas',
      branchId: branchId.value
    },
  ], superadmin.value, clinic.value.id)
  noty.info(i18n.t('success_message'))
  await store.dispatch('init')
}
</script>
